import React from 'react';

export function BehanceIcon({ size = 18, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} className={className}>
      <path d="M22 7h-7V5h7v2zm1.726 10c-.442 1.297-2.029 3-4.726 3-3.082 0-5.5-2.289-5.5-5.5 0-3.344 2.458-5.5 5.409-5.5 3.096 0 4.985 2.115 4.887 5.25H16.03c.097 1.765 1.408 2.65 2.87 2.65 1.157 0 2.062-.577 2.378-1.4h2.448zm-4.743-4.5c-.067-1.306-.948-2.15-2.257-2.15-1.378 0-2.213.882-2.316 2.15h4.573zM8.536 11.025C9.722 10.428 10.5 9.257 10.5 8c0-2.373-1.897-4-4.5-4H0v16h6.293c3.082 0 5.207-1.879 5.207-4.475 0-1.921-1.077-3.666-2.964-4.5zm-5.536-4.025h2.8c1.378 0 2.2.822 2.2 2 0 1.222-.822 2-2.2 2H3V7zm3.1 10H3v-4.5h3.293c1.555 0 2.407.925 2.407 2.25 0 1.353-.852 2.25-2.6 2.25z"/>
    </svg>
  );
}

export function DribbbleIcon({ size = 18, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="12" cy="12" r="10"/>
      <path d="M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94"/>
      <path d="M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32"/>
      <path d="M8.56 2.75c4.37 6 6 9.42 8 17.72"/>
    </svg>
  );
}

export function InstagramIcon({ size = 18, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
    </svg>
  );
}

export function TwitterXIcon({ size = 18, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  );
}

export function LinkedInIcon({ size = 18, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
      <rect width="4" height="12" x="2" y="9"/>
      <circle cx="4" cy="4" r="2"/>
    </svg>
  );
}

export function FacebookIcon({ size = 18, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  );
}
